"use strict";

import angular from "angular";
import moment from "moment";

const name = "dateMoment";
const factory = function dateMomentFilter() {
    return function (date, mask) {
        if (!(date instanceof moment)) return date;
        return date.format(mask);
    };
};
angular.module("nucont.shared").filter(name, factory);
export default { name, factory };
